import { useEffect, useState } from "react";

const GA_ID = "G-G9DJP13PRH";
const KEY = "upland_cookie_consent";

function loadGA() {
  if (window.__ga_loaded) return;
  window.__ga_loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID, { anonymize_ip: true });
}

export default function CookieConsent() {
  const [choice, setChoice] = useState(() => localStorage.getItem(KEY));

  useEffect(() => { if (choice === "accepted") loadGA(); }, [choice]);

  const decide = (v) => { localStorage.setItem(KEY, v); setChoice(v); };

  if (choice) return null;

  return (
    <div data-testid="cookie-consent" role="dialog" aria-label="Cookie consent"
      className="fixed bottom-4 inset-x-4 md:inset-x-auto md:right-6 md:max-w-md z-[100] bg-upland-green text-upland-creme border border-upland-creme/15 shadow-2xl p-5">
      <p className="text-sm leading-relaxed text-upland-creme/90">
        We use essential cookies to run this site and, with your consent, analytics cookies
        (Google Analytics) to understand how it's used. See our{" "}
        <a href="/legal/privacy" target="_blank" rel="noreferrer" className="underline underline-offset-2 hover:text-white">Privacy Policy</a>.
      </p>
      <div className="mt-4 flex items-center gap-3">
        <button data-testid="cookie-accept-btn" onClick={() => decide("accepted")}
          className="bg-upland-creme text-upland-green px-5 py-2 text-sm hover:bg-white transition-colors">
          Accept analytics
        </button>
        <button data-testid="cookie-decline-btn" onClick={() => decide("declined")}
          className="border border-upland-creme/40 text-upland-creme px-5 py-2 text-sm hover:bg-upland-brown/40 transition-colors">
          Decline
        </button>
      </div>
    </div>
  );
}
